import { render, staticRenderFns } from "./CreateCompetition.vue?vue&type=template&id=a2bfe1ee&"
import script from "./CreateCompetition.vue?vue&type=script&lang=js&"
export * from "./CreateCompetition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports